import React from "react";

const DeskNav = () => {
  return (
    <ul className="desknav">
      <li>
        <a href="#burgers">crazy burgers</a>
      </li>
      <li>
        <a href="#salads">crazy salads</a>
      </li>
      <li>
        <button>buy now</button>
      </li>
    </ul>
  );
};

export default DeskNav;
